import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { imageLogo, logoExt, logoWidth } from "../constants";
import { logoHeight, pageTitle } from '../constants/project-specific/project';
import { Link } from "@heroui/react";
export default function StakingLogo() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="relative h-full p-0 m-0">{imageLogo ? <Link href="../../../" rel="canonical" className="relative h-full p-0 m-0"><Image priority={true} src={`/logo.${logoExt}`} alt={`${pageTitle} Logo`} width={logoWidth} height={logoHeight} className="pr-1 md:pr-2 transition-all hover:scale-110 hover:skew-x-6 hover:-translate-x-2 p-0" /></Link> : <Image priority={true} src={`/logo.${logoExt}`} alt="Staking" width={30} height={30} className="pr-1 md:pr-2 transition-all hover:scale-110 hover:rotate-6" />}</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}